import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams, HttpRequest, HttpEventType, HttpResponse  } from '@angular/common/http';

//require('aws-sdk/dist/aws-sdk');
// AWS SDK
import * as AWS from 'aws-sdk/dist/aws-sdk';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/observable/of';
import { environment } from '../../environments/environment';
import { Subject } from 'rxjs';

@Injectable()
export class UploadFileService { 

  userInfo = JSON.parse(localStorage.getItem('currentUser'));
  username = this.userInfo.result.username;
  FOLDER = 'bidjones/' + this.username + '/';
  fileUploads = [];
  constructor(private http: HttpClient) { 
    // Check if environment supports native promises
    if (typeof Promise === 'undefined') {
      AWS.config.setPromisesDependency(Promise);
    }
  }

  uploadFile(files, type?) {
    let userInfo = JSON.parse(localStorage.getItem('currentUser'));
    let username = userInfo.result.username;
    let FOLDER = 'bidjones/' + username + '/';
    let AWS = (<any>window).AWS;

    var s3 = new AWS.S3({
        accessKeyId: environment.accessKeyId,
        secretAccessKey: environment.secretAccessKey,
        region: environment.region
    });

    if(type === "video") {
      const params = {
          Bucket: environment.s3Bucket,
          Key: this.FOLDER + files.name,
          Body: files,
          ACL: 'public-read',
          ContentType: files.type
      };
      return s3.upload(params).promise();
    } else {
      // Make all the putObject calls immediately
      // Will return rejected promise if any requests fail
      return Promise.all(files.map(function(file) {
      
        const params = {
              Bucket: environment.s3Bucket,
              Key: FOLDER + file.name,
              Body: file,
              ACL: 'public-read',
              ContentType: file.type
        };
        return s3.upload(params).promise();
      }));    
    }
  }

  // Upload file to aws serrver
  // uploadVideoFile(file)  {
  //   let resultData = [];

  //   let AWSService = (<any>window).AWS;
  //   const bucket = new AWSService.S3({
  //     accessKeyId: environment.accessKeyId,
  //     secretAccessKey: environment.secretAccessKey,
  //     region: environment.region
  //   });

  //   const params = {
  //     Bucket: environment.s3Bucket,
  //     Key: this.FOLDER + file.name,
  //     Body: file,
  //     ACL: 'public-read',
  //     ContentType: file.type
  //   };
    
  //   bucket.upload(params, function(err, data) {
  //     if(err) {
  //       return false;
  //     }
  //     resultData.push(data);
  //   });
   
  //   return resultData;
  // } 


  // Remove file from AWS server
  // deleteFile(filename, index) {
  //   let AWSService = (<any>window).AWS;
  //   const bucket = new AWSService.S3({
  //     accessKeyId: environment.accessKeyId,
  //     secretAccessKey: environment.secretAccessKey,
  //     region: environment.region
  //   });

  //   const params = {
  //     Bucket: environment.s3Bucket,
  //     Key:  this.FOLDER + filename
  //   };
    
  //   bucket.deleteObject(params, function (err, data) {
  //       if (data) {
  //       }
  //       else {
  //       }
  //   });
  // }

} 



// WEBPACK FOOTER //
// ./src/app/_services/upload-file.service.ts